import { type CarePlanStep, StepType } from "./types";

export function scrollCarePlanCanvasToCenterX(
  container: HTMLElement | null,
  canvas: HTMLElement | null,
): void {
  if (!container || !canvas) return;

  const targetScrollLeft =
    canvas.offsetLeft + canvas.offsetWidth / 2 - container.clientWidth / 2;
  const maxScrollLeft = Math.max(
    0,
    container.scrollWidth - container.clientWidth,
  );

  container.scrollLeft = Math.min(Math.max(0, targetScrollLeft), maxScrollLeft);
}

/** Runs sync + on the next frame so flex layout has settled. */
export function scheduleScrollCarePlanCanvasToCenterX(
  container: HTMLElement | null,
  canvas: HTMLElement | null,
): void {
  scrollCarePlanCanvasToCenterX(container, canvas);
  requestAnimationFrame(() => scrollCarePlanCanvasToCenterX(container, canvas));
}

function collectBranchIds(steps: CarePlanStep[], out: string[]): void {
  for (const step of steps) {
    if (step.type === StepType.DECISION && step.branches) {
      for (const branch of step.branches) {
        out.push(branch.id);
        collectBranchIds(branch.steps, out);
      }
    }
  }
}

/**
 * Value that changes when any branch is added or removed anywhere in the tree
 * (including nested decisions). Stable across unrelated step edits.
 */
export function getBranchStructureLayoutKey(steps: CarePlanStep[]): string {
  const ids: string[] = [];
  collectBranchIds(steps, ids);
  ids.sort();
  return ids.join("\0");
}
